var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_2042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0H3.9999C1.80015 0 0 1.80015 0 3.9999V12.0001C0 14.1993 1.80015 16 3.9999 16H11.9997C14.1995 16 15.9996 14.1993 15.9996 12.0001V3.9999C15.9996 1.80015 14.1995 0 11.9997 0ZM14.6662 12.0001C14.6662 13.4701 13.4705 14.6666 11.9997 14.6666H3.9999C2.52974 14.6666 1.33337 13.4701 1.33337 12.0001V3.9999C1.33337 2.52955 2.52974 1.33337 3.9999 1.33337H11.9997C13.4705 1.33337 14.6662 2.52955 14.6662 3.9999V12.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 4.6667C12.8862 4.6667 13.3339 4.21899 13.3339 3.66672C13.3339 3.11445 12.8862 2.66675 12.334 2.66675C11.7817 2.66675 11.334 3.11445 11.334 3.66672C11.334 4.21899 11.7817 4.6667 12.334 4.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 4C5.79035 4 4 5.79054 4 7.9999C4 10.2084 5.79035 12.0002 7.9999 12.0002C10.2088 12.0002 11.9998 10.2084 11.9998 7.9999C11.9998 5.79054 10.2088 4 7.9999 4ZM7.9999 10.6668C6.52732 10.6668 5.33337 9.47287 5.33337 7.9999C5.33337 6.52693 6.52732 5.33337 7.9999 5.33337C9.47248 5.33337 10.6664 6.52693 10.6664 7.9999C10.6664 9.47287 9.47248 10.6668 7.9999 10.6668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_2042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b2d1b869486e8174d070a29b468f4bac.svg";
export { ForwardRef as ReactComponent };